import Player from '../../AudioPlayer/Player';
import { COLORS } from '../../../config/designSystem/Colors';
import { FC, useState } from 'react';
import { H4 } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { SessionPresentationProps } from '../config';
import { Transcript } from './Transcript';
import { View, useWindowDimensions } from 'react-native';
import { isWeb } from '../../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { useBreakpointStyles } from '../../../hooks/useBreakpointStyles';

export interface Track {
  audioUrl: string | null;
  _id: string;
  title: string;
  transcript: string;
  transcriptVisible: string;
  albumArtUrl: string | null;
  subtitle: string | null;
  humanReadableId?: string;
  activityType?: string;
}

export interface ContentAudioData extends Record<string, unknown> {
  sessionStepId?: string;
  track?: Track;
  inPath?: boolean;
  setPositionMillis?: (value: number) => void;
  setPositionPercent?: (value: number) => void;
}

export interface PresentContentAudioProps extends SessionPresentationProps<ContentAudioData> {
  labels?: {
    NO_INTERNET?: string;
    STEP_AUDIO?: string;
    TRANSCRIPTION?: string
  }
  data: ContentAudioData,
}

const _PresentContentAudio: FC<PresentContentAudioProps> = ({
  labels,
  data,
}) => {
  const track = data?.track;
  const sessionStepId = data?.sessionStepId;
  const [isCollapsed, setIsCollapsed] = useState(true);
  const {width} = useWindowDimensions();

  const styles = useBreakpointStyles({
    container: {
      width: '100%',
      flex: 1,
    },
    wrapper: {
      flex: 1,
      lg: { height: 'auto' },
      xl: { height: 'auto' },
    },
    playerContainer: {
      marginBottom: SPACING['sp-20'],
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    titleContainer: {
      ...(!!track?.transcriptVisible && { marginBottom: 15 }),
    },
    transcriptContainer: {
      flex: 1,
      md: { flex: 1, paddingHorizontal: SPACING['sp-64'] },
      lg: { flex: 1, paddingHorizontal: SPACING['sp-100'] },
      xl: { flex: 1, paddingHorizontal: SPACING['sp-200'] },
    },
    player: {
      height: 400,
      width: 300,
      sm: { height: 400, width: 300 },
      md: { height: 500, width: width - 128},
      lg: { height: 600, width: width - 200},
      xl: { height: 600, width: width - 400},
    }
  });

  return (
    <View style={styles.container}>
      <View style={styles.wrapper}>

        <View style={styles.playerContainer}>
          <View style={styles.titleContainer}>
            <H4 align={true}>{track?.title}</H4>
          </View>
          <Player
            tracks={[track!]}
            hideBack={false}
            hideForward={false}
            defineVariables={() => {}}
            height={styles.player.height}
            width={styles.player.width}
            smallPlayer={!isCollapsed && !isWeb}
            color={COLORS.content.accent}
            selectedTrack={0}
            noInternet={labels?.NO_INTERNET? labels?.NO_INTERNET: 'no internet.'}
            setPositionMillis={data?.setPositionMillis}
            setPositionPercent={data?.setPositionPercent}
          />
        </View>
        {track?.transcriptVisible ? (
          <View style={styles.transcriptContainer}>
            <Transcript
              track={track}
              isCollapsed={isCollapsed}
              setIsCollapsed={setIsCollapsed}
              labels={labels}
              sessionStepId={sessionStepId}
            />
          </View>) : null }
      </View>
    </View>
  );
};

export const PresentContentAudio = observer(_PresentContentAudio);


